import {
    Platform
} from "react-native";
import DeviceInfo from "react-native-device-info";
import {
    storage
} from "../../../storage";

export const getHeaders = (isAuth?: boolean, params?: Record<string, unknown>) => {
    const additionalParams: {
        Authorization?: string;
    } = {
    };

    if(isAuth) {
        const accessToken = storage.getString("accessToken");

        if(accessToken) {
            additionalParams.Authorization = accessToken;
        }
    }

    const defaultHeaders: Record<string, string | number> = {
        "Content-Type": "application/json",
        "Accept": "application/json"
    };

    if (Platform.OS !== "web") {
        defaultHeaders["buildNumber"] = Number(DeviceInfo.getBuildNumber());
        defaultHeaders["currentVersion"] = DeviceInfo.getVersion();
        defaultHeaders["platform"] = Platform.OS;
    }

    return {
        ...defaultHeaders,
        ...additionalParams,
        ...params
    };
};

export const truncateText = (text: string, maxLength = 10) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + "...";
};

export const normalizeText = (text: string) => {
    return text.replace(/\s+/g, " ").trim();
};
